import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import PropTypes from 'prop-types';

const AirDropSuccessModal = ({ modalOpen, modalClose, reward, rewardStatus }) => {

    const navigate = useNavigate()
    const close = async () => {
        modalClose()
        navigate('/profile-details')
    }

    const closeBtn = <button className="close" onClick={close}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.3359 10.5L16.5547 14.7188C16.7891 14.9531 16.7891 15.3828 16.5547 15.6172L15.5781 16.5938C15.3438 16.8281 14.9141 16.8281 14.6797 16.5938L10.5 12.375L6.28125 16.5938C6.04688 16.8281 5.61719 16.8281 5.38281 16.5938L4.40625 15.6172C4.17188 15.3828 4.17188 14.9531 4.40625 14.7188L8.625 10.5L4.40625 6.32031C4.17188 6.08594 4.17188 5.65625 4.40625 5.42188L5.38281 4.44531C5.61719 4.21094 6.04688 4.21094 6.28125 4.44531L10.5 8.66406L14.6797 4.44531C14.9141 4.21094 15.3438 4.21094 15.5781 4.44531L16.5547 5.42188C16.7891 5.65625 16.7891 6.08594 16.5547 6.32031L12.3359 10.5Z" fill="#6E737E" />
        </svg>
    </button>;

    return (
        <Modal isOpen={modalOpen} centered="true" className="mymodal airdropSuccessModal" backdropClassName="modalbackbg">
            <ModalHeader className='pb-0 border-bottom-0' close={closeBtn}></ModalHeader>
            <ModalBody className='pt-0'>
                <div className='text-center'>
                    <div className='def-mb-12'>
                        <img src={require('../../assets/images/greenCircleTick.gif')} alt='greenCircleTick.gif' className='gifImg' />
                    </div>

                    {
                        !rewardStatus ?
                            <>
                                <div className='mb-2 fs-24 fw-100 nexaFont'><span>Airdrop Deposit</span></div>
                                <div className='mb-4 textGreenTxt'>
                                    {reward} TPL  Successfully
                                    <p>Account activated Successfully
                                    </p>

                                </div>
                            </>
                            :
                            <div className='mb-4 textGreenTxt'>
                                Account activated Successfully
                            </div>
                    }

                    <div className='mt-4 mb-3'>
                        <Link to={'/profile-details'} className='btn btn-primary fs-18 fw-600 px-4 px-lg-5'>Update Profile</Link>
                    </div>
                </div>

            </ModalBody>
        </Modal>
    )
}
AirDropSuccessModal.propTypes = {
    modalOpen: PropTypes.any.isRequired,
    modalClose: PropTypes.any.isRequired,
    reward: PropTypes.any,
    rewardStatus: PropTypes.any.isRequired,
};


export default AirDropSuccessModal;